import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  li:first-child {\n    ",
        ";\n  }\n  li:last-child {\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  &:first-child {\n    ",
        "\n  }\n\n  &:last-child {\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { Transition } from "react-transition-group";
import Button from "../button/Button";
import { CheckMark, Planet } from "../icons";
import { VisuallyHidden } from "../text";
import Box from "../layout/Box";
import Link from "../link/Link";
import useOnClickOutside from "../../hooks/useOnClickOutside";
var SwitcherContainer = styled(Box).attrs({
    $styles: {
        position: "relative",
        zIndex: 100
    }
}).withConfig({
    componentId: "sc-1b0018c8-0"
})(_templateObject());
var PopupListWrapper = styled(Box).attrs(function(param) {
    var _$styles = param.$styles, $styles = _$styles === void 0 ? {} : _$styles, theme = param.theme, $isExpanded = param.$isExpanded, $position = param.$position;
    return {
        $p: [
            theme.spaces.md,
            theme.spaces.lg
        ],
        $styles: _object_spread_props(_object_spread({}, $styles), {
            position: [
                "fixed",
                "fixed",
                "absolute"
            ],
            top: $position === "top" ? "auto" : [
                null,
                null,
                30
            ],
            bottom: $position === "top" ? [
                null,
                null,
                30
            ] : "auto",
            left: [
                0,
                0,
                -24
            ],
            right: [
                0,
                0,
                null
            ],
            minWidth: 248,
            borderRadius: [
                null,
                null,
                4
            ],
            boxShadow: $isExpanded ? "0 4px 16px 0 rgba(5, 0, 56, 0.16)" : null,
            background: theme.colors.primaryWhite,
            textAlign: "left",
            ":before": {
                content: "''",
                height: 6,
                position: "absolute",
                left: 0,
                right: 0,
                top: $position === "top" ? null : -6,
                bottom: $position === "top" ? -6 : null
            }
        })
    };
}).withConfig({
    componentId: "sc-1b0018c8-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, $isExpanded = param.$isExpanded;
    return theme.normalizeStyles({
        bottom: $isExpanded ? [
            0,
            0,
            null
        ] : [
            "-100%",
            "-100%",
            null
        ]
    });
});
var PopupList = styled(Box).attrs({
    as: "ul",
    role: "menu"
}).withConfig({
    componentId: "sc-1b0018c8-2"
})(_templateObject2(), function(props) {
    return props.theme.normalizeStyles({
        paddingTop: [
            null,
            0
        ]
    });
}, function(props) {
    return props.theme.normalizeStyles({
        paddingBottom: [
            null,
            0
        ]
    });
});
var PopupListItem = styled(Box).attrs({
    as: "li",
    $styles: {
        position: "relative"
    },
    $py: 8
}).withConfig({
    componentId: "sc-1b0018c8-3"
})(_templateObject3());
var PopupTitle = styled(Box).attrs(function(props) {
    return {
        $styles: {
            display: [
                "block",
                "block",
                "none"
            ],
            fontSize: 16,
            lineHeight: 24,
            fontWeight: 500,
            color: props.theme.colors.primaryIndigo,
            position: "relative"
        },
        $pt: 8,
        $pb: 16
    };
}).withConfig({
    componentId: "sc-1b0018c8-4"
})(_templateObject4());
var PopupCloseButton = styled(Button).attrs({
    $styles: {
        width: 32,
        height: 32,
        position: "absolute",
        top: "50%",
        right: -4,
        transform: "translateY(-50%) rotate(45deg)"
    }
}).withConfig({
    componentId: "sc-1b0018c8-5"
})(_templateObject5());
var PopupCloseLine = styled(Box).attrs(function(props) {
    return {
        $styles: {
            background: props.theme.colors.primaryIndigo,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        }
    };
}).withConfig({
    componentId: "sc-1b0018c8-6"
})(_templateObject6(), function(props) {
    return props.theme.normalizeStyles({
        width: 22,
        height: "2px"
    });
}, function(props) {
    return props.theme.normalizeStyles({
        width: "2px",
        height: 22
    });
});
var duration = 250;
var collapsedStyles = {
    opacity: 0,
    visibility: "hidden",
    transition: "box-shadow ".concat(duration, "ms 0ms, \n      transform ").concat(duration, "ms 0ms, \n      opacity ").concat(duration, "ms 0ms, \n      bottom ").concat(duration, "ms 0ms, \n      visibility 0ms ").concat(duration, "ms"),
    transform: "translateY(0)"
};
var expandedStyles = {
    visibility: "visible",
    transform: "translateY(0)",
    transition: "visibility 0ms 0ms,\n  opacity ".concat(duration / 3, "ms 0ms,\n  bottom ").concat(duration, "ms 0ms,\n  transform ").concat(duration, "ms 0ms,\n  box-shadow ").concat(duration / 3, "ms\n    ").concat(duration / 4, "ms;\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(0)\n  ")
};
var transitionStyles = {
    entering: _object_spread({
        opacity: 0
    }, expandedStyles),
    entered: _object_spread({
        opacity: 1
    }, expandedStyles)
};
var TYPOGRAPHY_STYLES = {
    fontSize: [
        18,
        18,
        16,
        18,
        18
    ],
    lineHeight: [
        32,
        22,
        22,
        24,
        24
    ]
};
var LanguageLink = styled(Link).attrs(function(param) {
    var $isActive = param.$isActive, theme = param.theme;
    return {
        $styles: _object_spread({
            color: $isActive ? theme.colors.primaryBlue : theme.colors.primaryIndigo,
            transition: "color ".concat(theme.animation.transitionDuration),
            textDecoration: "none",
            ":hover": {
                color: theme.colors.primaryBlueHover
            },
            ":focus": _object_spread({}, theme.focus.outlines.withOffset),
            width: "100%"
        }, TYPOGRAPHY_STYLES)
    };
}).withConfig({
    componentId: "sc-1b0018c8-7"
})(_templateObject7());
var LanguageCheckMark = styled(CheckMark).withConfig({
    componentId: "sc-1b0018c8-8"
})(_templateObject8(), function(props) {
    return props.theme.normalizeStyles({
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)"
    });
});
var LanguagePopup = function(props) {
    var isExpanded = props.isExpanded, translations = props.translations, onCloseClick = props.onCloseClick, onSelect = props.onSelect, position = props.position, currentLocale = props.currentLocale, setExpanded = props.setExpanded;
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(Transition, {
        in: isExpanded,
        timeout: 250,
        children: function(state) {
            return /*#__PURE__*/ _jsxs(PopupListWrapper, {
                $isExpanded: isExpanded,
                $styles: _object_spread({}, !isExpanded ? collapsedStyles : {}, transitionStyles[state]),
                $position: position,
                children: [
                    /*#__PURE__*/ _jsxs(PopupTitle, {
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                $styles: _object_spread({}, TYPOGRAPHY_STYLES),
                                children: "Choose website language"
                            }),
                            /*#__PURE__*/ _jsxs(PopupCloseButton, {
                                onClick: onCloseClick,
                                children: [
                                    /*#__PURE__*/ _jsx(PopupCloseLine, {}),
                                    /*#__PURE__*/ _jsx(PopupCloseLine, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(PopupList, {
                        children: translations.map(function(t) {
                            return /*#__PURE__*/ _jsxs(PopupListItem, {
                                children: [
                                    /*#__PURE__*/ _jsx(LanguageLink, {
                                        "data-locale": t.locale,
                                        "data-testid": "item-".concat(t.locale),
                                        onClick: function(e) {
                                            setExpanded(false);
                                            onSelect(e, t);
                                        },
                                        href: t.url,
                                        $isActive: t.locale === currentLocale.locale,
                                        children: t.localeLabel || t.locale
                                    }),
                                    t.locale === currentLocale.locale && /*#__PURE__*/ _jsx(LanguageCheckMark, {
                                        color: theme.colors.primaryBlue
                                    })
                                ]
                            }, t.locale);
                        })
                    })
                ]
            });
        }
    });
};
var SwitcherIcon = styled(Planet).withConfig({
    componentId: "sc-1b0018c8-9"
})(_templateObject9(), function(props) {
    return props.theme.normalizeStyles({
        marginRight: [
            8,
            8,
            0,
            8,
            8
        ],
        width: 24,
        height: 24
    });
});
var SwitcherCurrentLocale = styled(Box).attrs({
    $styles: {
        textTransform: "uppercase"
    }
}).withConfig({
    componentId: "sc-1b0018c8-10"
})(_templateObject10());
var SwitcherButton = styled(Button).attrs(function(param) {
    var $color = param.$color, theme = param.theme, $isActive = param.$isActive;
    var activeColor = $color === "white" ? theme.colors.outspoken : theme.colors.primaryBlueHover;
    return {
        $styles: {
            fontSize: [
                18
            ],
            lineHeight: 24,
            display: "flex",
            alignItems: "center",
            color: $isActive ? activeColor : $color === "white" ? theme.colors.primaryWhite : theme.colors.primaryIndigo,
            ":hover": {
                color: activeColor
            },
            ":focus": _object_spread({}, theme.focus.outlines.withOffset),
            transition: "color 250ms ease"
        }
    };
}).withConfig({
    componentId: "sc-1b0018c8-11"
})(_templateObject11());
var LanguageSwitcher = function(props) {
    var color = props.color, currentLocale = props.currentLocale, translations = props.translations, onSelect = props.onSelect;
    var ref = useState(translations), translationsState = ref[0], setTranslationsState = ref[1];
    var ref1 = useState(false), isExpanded = ref1[0], setExpanded = ref1[1];
    var ref2 = useRef(null);
    if (!currentLocale || translations.length === 0) {
        return null;
    }
    useOnClickOutside(ref2, function() {
        if (isExpanded) {
            setExpanded(false);
        }
    });
    useEffect(function() {
        if (!(translations === null || translations === void 0 ? void 0 : translations.length)) {
            return;
        }
        // * put english first and sort the rest
        setTranslationsState(translations.sort(function(a, b) {
            var ref, ref1;
            var EN = "en";
            var labelA = a.localeLabel || "";
            var labelB = b.localeLabel || "";
            if (((ref = a.locale) === null || ref === void 0 ? void 0 : ref.toLowerCase()) == EN) {
                return -1;
            }
            if (((ref1 = b.locale) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) == EN) {
                return +1;
            }
            if (labelA > labelB) {
                return 1;
            }
            if (labelB > labelA) {
                return -1;
            }
            return 0;
        }));
    }, [
        translations
    ]);
    return /*#__PURE__*/ _jsxs(SwitcherContainer, {
        "data-track-place": "Language Switcher",
        ref: ref2,
        children: [
            /*#__PURE__*/ _jsxs(SwitcherButton, {
                "data-testid": "SwitcherButton",
                "aria-haspopup": true,
                "aria-expanded": isExpanded,
                $isActive: isExpanded,
                onClick: function() {
                    return setExpanded(!isExpanded);
                },
                $color: color,
                children: [
                    props.hideSelectedLabel ? /*#__PURE__*/ _jsx(SwitcherIcon, {
                        style: {
                            marginRight: 0
                        },
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(SwitcherIcon, {
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ _jsx(SwitcherCurrentLocale, {
                                "aria-hidden": true,
                                children: currentLocale.locale
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(VisuallyHidden, {
                        children: [
                            "Current language is: ",
                            currentLocale.localeLabel || currentLocale.locale
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LanguagePopup, {
                setExpanded: setExpanded,
                onSelect: onSelect,
                isExpanded: isExpanded,
                currentLocale: currentLocale,
                translations: translationsState,
                onCloseClick: function() {
                    return setExpanded(false);
                },
                position: props.position
            })
        ]
    });
};
export default Object.assign(LanguageSwitcher, {
    SwitcherCurrentLocale: SwitcherCurrentLocale
});
